import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
export var NetworkInfo = function NetworkInfo() {
    _classCallCheck(this, NetworkInfo);

    this.type = '';
    this.ip = '';
    this.cellType = '';
    this.mac = '';
    this.ssid = '';
};
export var NetworkStatus = function NetworkStatus() {
    _classCallCheck(this, NetworkStatus);

    this.isOnline = false;
};
export var NetworkPingStatus = function NetworkPingStatus() {
    _classCallCheck(this, NetworkPingStatus);

    this.isOnlinePing = false;
};